<template>
    <div>

        <div style="padding: 10px;">
            <van-card v-for="item,index in clientlist" :key="index">
                <template #title>
                    <div v-if="name!=='面访记录'" class="title">{{item.name||item.khmc}}</div>
                    <div v-if="name=='面访记录'" class="title">{{item.subject}}</div>
                </template>
                <template #tags>
                    <div class="desc">
                        <div v-if="name=='面访记录'">相关客户 ：{{ item.client }}</div>
                        <div v-if="name=='面访记录'">拜访时间 ：{{ item.create_time }}</div>
                        <div v-if="name=='面访记录'">拜访地址 ：{{ item.location_title }}</div>
                        <div v-if="name=='面访记录'">参与拜访人员 ：{{ item.visiting_personnel }}</div>

                        <div v-if="name=='出差申请'"> 出差申请编号：{{ item.ccsq||item.ccsq }}</div>
                        <div v-if="name=='出差申请'"> 出差地点：{{ item.ccdd||item.ccdd }}</div>
                        <div v-if="name=='商机'">商机阶段：{{ item.jieduan }}</div>
                        <div>CRM客户编码：{{ item.khbmccc||item.crm_customer_code}}</div>
                        <div v-if="name=='客户'||name=='高开工设备'">综合业务客户分级：{{ item.fenji }}</div>
                        <div v-if="name=='高开工设备'">所有人：{{ item.syr }}</div>
                        <div v-if="name=='客户'">用户ID：{{ item.userid }}</div>
                        <div v-if="name!=='面访记录'"> 首次创建联系人：{{ item.sccjlxr }}</div>
                        <div v-if="name!=='面访记录'"> 首次创建联系手机：{{ item.zlxrdh }}</div>
                        <div v-if="name1=='拜访任务'">备注：{{ item.remark1 }}</div>

                    </div>
                </template>
                <template #footer>
                    <van-button @click="onClickcheckin(item)" v-if="name!=='面访记录'" color="#FBAC01"
                        size="small">面访签到</van-button>
                    <van-button @click="onClickchecklog(item)" v-if="name=='面访记录'" color="#FBAC01"
                        size="small">查看详情</van-button>
                    <van-button @click="onClicknoFollowUp(item)" v-if="name=='高开工设备'" color="#FBAC01"
                        size="small">暂不跟进</van-button>
                </template>
            </van-card>
        </div>
    </div>
</template>

<script>
import { qiweiAPI } from '../../../api/qiwei.js';
    export default {
        props: {
            name: {
                type: String,
                default: '',
            },
            name1: {
                type: String,
                default: '',
            },
            clientlist: {
                type: Array,
                default: [],
            },
        },
        data() {
            return {
                value: '',
            };
        },
        methods: {
            onClickcheckin(obj) {
                console.log(obj);
                obj.visiting_source = this.name == '出差申请' ? '出差申请' : '事件'
                obj.type = this.name == '客户'||this.name == '高开工设备' ? 1 : this.name == '大客户' ? 2 : this.name == '商机' ? 3 : 4
                obj.typename = this.name
                // return
              
                this.$router.push({ path: '/qiwei/checkin', query: obj })
            },
            onClickchecklog(obj) {
                var parm = {
                    crm_user_id: obj.crm_user_id,
                    getSignInDetails: obj.id
                }
                this.$router.push({ path: '/qiwei/interviewinginfo', query: parm })
            },
            onClicknoFollowUp(item) {
                this.$emit('onClicknoFollowUp',{data_id:item.id});
            }
        }
    }
</script>

<style>
    .title {
        font-size: 14px;
        font-weight: 600;
        margin-top: 10px;
    }

    .desc {
        font-size: 12px;
        color: #aeaeae;
    }

    .desc div {
        padding-top: 5px;
        ;
    }
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/component/kuhuList.vue